module.exports = __webpack_public_path__ + "static/The-Synergistic-Benefits-of-Cupping-and-Physical-Therapy-6e5251f6fc13359ed46e703b7c5f6e92.webp";